import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CoreDialog,
    {
      attrs: {
        "data-qa": "banner-mt-link-modal",
        size: _setup.isMobile ? "fullscreen" : "xl",
        persistent: "",
      },
      scopedSlots: _vm._u(
        [
          {
            key: "prependBtn",
            fn: function ({ btnProps }) {
              return [
                _c(
                  VBtn,
                  _vm._b(
                    { on: { click: _setup.close } },
                    "v-btn",
                    btnProps,
                    false
                  ),
                  [_c("span", { staticClass: "ui-icon-close-not-a-circle" })]
                ),
              ]
            },
          },
          _setup.isMobile
            ? {
                key: "actions",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column ga-2 flex-grow-1" },
                      [
                        _c(
                          VBtn,
                          {
                            attrs: {
                              "data-qa": "modal-actions-btn-confirm",
                              color: "primary",
                              block: "",
                              depressed: "",
                            },
                            on: { click: _setup.installApp },
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _setup.translate("Установить приложение")
                                ) +
                                "\n      "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          VBtn,
                          {
                            attrs: {
                              "data-qa": "modal-actions-btn-close",
                              color: "primary",
                              block: "",
                              text: "",
                            },
                            on: { click: _setup.close },
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(_setup.translate("Закрыть")) +
                                "\n      "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              }
            : null,
        ],
        null,
        true
      ),
      model: {
        value: _setup.isOpened,
        callback: function ($$v) {
          _setup.isOpened = $$v
        },
        expression: "isOpened",
      },
    },
    [
      _vm._v(" "),
      _c(_setup.BannerMtLinkSlider, {
        staticClass: "pb-2",
        attrs: { slides: _setup.slides, "is-mobile": _setup.isMobile },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }